import SocketClient from './socket';

const PDF_EVENTS = {
  END_OF_PARSING: 'success',
  PARSED_PAGE: 'success_page'
};

class PdfProcessingManager {
  constructor () {
    this._channel = null;
    this._project = null;
  }

  subscribe (project) {
    this._channel || this._listenToUpdates();
    this._project = project;
  }

  isBeingProcessed (pageNumber) {
    if (!this._project) return false;
    if (!this._project.is_being_processed) return false;
    if (!this._project.metadata || !this._project.metadata.svg_status) return true;

    return !this._project.metadata.svg_status
      .find(s => parseInt(s.page_number) === pageNumber);
  }

  _listenToUpdates () {
    const socketClient = new SocketClient();
    this._channel = socketClient.openChannel({
      successCallback: update => this._onUpdate(update),
      channelId: `webrand_parser_${INKIVE.C.BOOK.encodedId}`
    });
  }

  _onUpdate (update) {
    const currentPageWasBeingProcessed = this.isBeingProcessed(INKIVE.Tool._current_page_number);

    update.status = (update.status || '').toLowerCase();

    if (update.status === PDF_EVENTS.END_OF_PARSING) {
      this._project.is_being_processed = false;
      this._channel.dispose();
    } else if (update.status === PDF_EVENTS.PARSED_PAGE) {
      this._project.metadata = this._project.metadata || {};
      this._project.metadata.svg_status = this._project.metadata.svg_status || [];
      this._project.metadata.svg_status.push(update);
    }

    currentPageWasBeingProcessed &&
      !this.isBeingProcessed(INKIVE.Tool._current_page_number) &&
      this._reloadCurrentPage();
  }

  async _reloadCurrentPage () {
    const id = INKIVE.Tool._current_design_id;
    const tool = INKIVE.Tool.getInstance();
    const canvas = tool.editor.canvas;

    INKIVE.Tool._current_design_id = null;
    await INKIVE.EditorFacade.handle('page', 'move_to', { save: false, design_id: id });
    canvas.call('advice.show', 'pdf-ready');
  }
}

export default new PdfProcessingManager();
